<template>
  <div class="box has-background-light" id="stud_list_pond">
  <div v-if="isLoading" class="loading">Loading&#8230;</div>

<div class="columns is-gapless" style="margin-top:.5em;margin-bottom:0em;">
    <div class="column is-6 has-text-weight-bold is-size-5">{{course_title}}</div>



  <div class="column is-2 has-text-right has-text-weight-bold">Remark &nbsp;&nbsp;</div>
    <div class="column is-2 has-text-centered">
        <!-- <button @click="toggle_notes_mod()" class="button is-fullwidth has-text-weight-bold" style="background-color:LIGHTCORAL;color:white"><span class="icon has-text-left"><i class="fas fa-window-close"></i></span>     </button> -->

    <div class="control">
    <div class="select is-fullwidth">
        <select v-model="data_group[0].cs_REMARK">
        <option></option>
        <option>EC</option>
        <option>EQ</option>
        <option>IN</option>
        </select>
    </div>
    </div>


    </div>
    <div class="column is-2 has-text-centered">
        <button @click="notes_save()" class="button is-fullwidth has-text-weight-bold" style="background-color:OLIVEDRAB;color:white">
            <span class="icon has-text-left"><i class="fas fa-save"></i></span>     
        </button>
    </div>





</div>


<div class="columns is-gapless is-mobile has-text-grey-dark" style="margin-bottom:0em;">
<div class="column is-2 colBorder has-text-centered has-background-light isLabel">DESC.</div>
<div class="column is-2 colBorder has-text-centered has-background-light isLabel">POUR.</div>
<div class="column is-2 colBorder has-text-centered has-background-light isLabel">MAX</div>
<div class="column is-2 colBorder has-text-centered has-background-light isLabel">NOTE</div>

<div class="column is-2 colBorder has-text-centered has-background-light isLabel">AVG</div>
<div class="column is-2 colBorder has-background-grey-dark has-text-white	 has-text-centered doFontSmaller">COUR AVG.</div>

</div>

<div class="columns is-gapless is-mobile has-text-weight-bold" style="margin-bottom:0em;" v-for ="(data, index) in data_ponderation" :key="index">
<div class="column is-2 colBorder has-background-white doFontSmaller">&nbsp;{{data.desc}}</div>
<div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">{{data.perc}}%</div>
<div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">{{data.max}}</div>
<div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">
<!-- {{check_number(data.note_NOTE)}}-->
    <input :disabled="!mod_notes" @change="note_change(index)"  v-model="data.note" min="0" 
      class="input is-fullwidth has-background-warning has-text-centered has-text-weight-bold" type="number" 
      placeholder="note" value="">
</div>
<div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">{{check_number(data.avg)}}</div>


<div v-if="index == 0" class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">{{group_avg}}</div>


<!-- <template v-if="data.goodToGo">
  <div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">{{return_average(data.note_NOTE, data.ponderation_Max)}}</div>
  <div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller">{{return_average(data.ponderation_AVG, data.ponderation_Max)}}</div>  
</template>
<template v-else>
  <div class="column is-2 colBorder has-background-white has-text-centered has-text-warning doFontSmaller"><span class="icon" style=""><i class="fas fa-clock"></i></span></div>
  <div class="column is-2 colBorder has-background-white has-text-centered doFontSmaller"></div> 
</template> -->







</div>



  </div>
</template>


<script>
import axios from 'axios';


export default {
    props: [ 'student_id' , 'group_id', 'group_avg', 'course_title' ],
    
  data: function() {
    return {
        isLoading : false,
        data_ponderation:[],
        data_group:[],
        no_display:'',
        mod_notes:true,
    }
  },


created() {
    this.get_details() 
},

  methods: {

note_change:function(index) {

   // alert(this.data_ponderation[index].n_id)

},

notes_save() {

 
var sql = '';
this.data_ponderation.forEach(function(dataNote){
    if (dataNote.n_id == "0" )
    { 
        if (dataNote.note != '') {        
            sql +=  "INSERT INTO MyMEQ_PROF_NOTES (ponderation_ID, cs_ID,note_NOTE) VALUES ("
            sql += dataNote.pond_id + "," + dataNote.cs_id + "," + dataNote.note + ");"
        }
    }
    else 
    { sql += "UPDATE MyMEQ_PROF_NOTES SET note_NOTE = " + dataNote.note + " WHERE note_ID = " + dataNote.n_id + ";"  }


// UPDATE AVG PONDERATION
sql += `UPDATE MyMEQ_PROF_PONDERATION SET ponderation_AVG = ROUND ( (SELECT AVG(CAST(note_NOTE AS float)) AS pondAvg FROM MyMEQ_PROF_NOTES 
WHERE (ponderation_ID = ` + dataNote.pond_id + `)), 0)
WHERE  (ponderation_ID = ` + dataNote.pond_id + `);`

});


if (this.data_group[0].cs_REMARK == 'null') {this.data_group[0].cs_REMARK = null}
else {this.data_group[0].cs_REMARK = "'" + this.data_group[0].cs_REMARK + "'"}
 

// UPDATE STUDENT AVERAGE
sql += `UPDATE       MyMEQ_COURSESTUDENT
SET cs_REMARK = ` + this.data_group[0].cs_REMARK + `, cs_MARK = ROUND (
(SELECT SUM((CAST(MyMEQ_PROF_NOTES.note_NOTE AS float) / CAST(MyMEQ_PROF_PONDERATION.ponderation_Max AS float) * 100) 
 * (CAST(MyMEQ_PROF_PONDERATION.ponderation_Percent AS float) / 100)) AS Expr1
 FROM MyMEQ_COURSESTUDENT AS MyMEQ_COURSESTUDENT_1 INNER JOIN
 MyMEQ_PROF_NOTES ON MyMEQ_COURSESTUDENT_1.cs_ID = MyMEQ_PROF_NOTES.cs_ID INNER JOIN
 MyMEQ_PROF_PONDERATION ON MyMEQ_PROF_NOTES.ponderation_ID = MyMEQ_PROF_PONDERATION.ponderation_ID
 WHERE (MyMEQ_COURSESTUDENT_1.group_ID = ` + this.group_id + `) AND (MyMEQ_COURSESTUDENT_1.student_ID = ` + this.student_id + `)),0)
 WHERE (group_ID = ` + this.group_id + `) AND (student_ID = ` + this.student_id + `);`


// UPDATE AVG GROUP
sql += `UPDATE MyMEQ_GROUP SET group_AVG = ROUND ( (SELECT AVG(CAST(cs_MARK AS float)) AS courAvg FROM MyMEQ_COURSESTUDENT 
WHERE (group_ID = ` + this.group_id + `)) , 0)
WHERE  (group_ID = ` + this.group_id + `);`


console.log(sql)

  axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
  .then(res => { 
    this.mod_notes = false 
    this.get_details(true) // RE-GET NOTES
    });


},




toggle_notes_mod:function() {
    if(+this.mod_notes) 
    { 

        this.get_details()
        this.mod_notes = false }
    else {

        this.mod_notes = true
    }
},


check_number:function(val) {
    return val

    //  if (typeof val == 'number') 
    // {return Math.round(+val)}
    // else { return ''} 
},


get_details(doEmit) {
    this.isLoading=true;

var sql = '';

// GET STUDENT INFO ----> SAME PROCESS AS GROUPS
sql = `SELECT MyMEQ_STUDENT.student_ID, MyMEQ_STUDENT.student_lNAME,MyMEQ_STUDENT.student_fNAME,student_GRPCODE,student_PhotoPath, MyMEQ_PROF_NOTES.note_ID , MyMEQ_PROF_NOTES.note_NOTE, MyMEQ_PROF_PONDERATION.*  ,MyMEQ_COURSESTUDENT.cs_ID,cs_MARK,cs_REMARK, MyMEQ_GROUP.group_AVG, MyMEQ_GROUP.group_blnComplete, MyMEQ_GROUP.group_PUBLIC FROM  MyMEQ_STUDENT INNER JOIN MyMEQ_COURSESTUDENT ON MyMEQ_STUDENT.student_ID = MyMEQ_COURSESTUDENT.student_ID  LEFT OUTER JOIN MyMEQ_PROF_NOTES ON MyMEQ_COURSESTUDENT.cs_ID = MyMEQ_PROF_NOTES.cs_ID LEFT OUTER JOIN MyMEQ_PROF_PONDERATION ON MyMEQ_PROF_NOTES.ponderation_ID = MyMEQ_PROF_PONDERATION.ponderation_ID LEFT OUTER JOIN  MyMEQ_GROUP ON MyMEQ_PROF_PONDERATION.group_ID = MyMEQ_GROUP.group_ID 
WHERE MyMEQ_COURSESTUDENT.student_ID = ` + this.student_id + ` AND MyMEQ_COURSESTUDENT.group_ID = ` + this.group_id + ` ORDER BY ponderation_Order`
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { 
    this.data_group = res.data

// GET PONDERATIONS
var sql = 'SELECT * FROM MyMEQ_PROF_PONDERATION WHERE group_ID = ' + this.group_id + " ORDER BY ponderation_Order"
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
.then(res => { 
    var dataTmp = res.data
    var tempArr = []

var self=this;
dataTmp.forEach(function(dataPond){ 
    var indx = self.data_group.findIndex(x => x.ponderation_ID == dataPond.ponderation_ID)
    if (indx > -1) 
    {tempArr.push({ note : self.data_group[indx].note_NOTE, n_id : self.data_group[indx].note_ID, pond_id : self.data_group[indx].ponderation_ID, cs_id : self.data_group[indx].cs_ID, stud_id : self.data_group[indx].student_ID, desc : dataPond.ponderation_Desc,perc : dataPond.ponderation_Percent,max : dataPond.ponderation_Max,avg : dataPond.ponderation_AVG});}
    else {tempArr.push({ note : null, n_id : 0, pond_id : dataPond.ponderation_ID, cs_id : self.data_group[0].cs_ID, desc : dataPond.ponderation_Desc,perc : dataPond.ponderation_Percent,max : dataPond.ponderation_Max,avg : dataPond.ponderation_AVG});}  

}) // END POND LOOP

this.data_ponderation = tempArr;
this.isLoading=false;

// CHECK IF JUST UPDATED!
if (doEmit) {
  this.$emit('emit_note_change',this.data_group[0].group_AVG,this.data_group[0].cs_MARK,this.data_group[0].cs_REMARK)
}




});
});
    
/*     sql=`
        SELECT MyMEQ_COURSESTUDENT.cs_ID, MyMEQ_PROF_NOTES.note_NOTE,MyMEQ_PROF_NOTES.note_ID, MyMEQ_PROF_PONDERATION.ponderation_Desc, MyMEQ_PROF_PONDERATION.ponderation_Percent, MyMEQ_PROF_PONDERATION.ponderation_AVG, MyMEQ_PROF_PONDERATION.ponderation_PUBLIC, MyMEQ_PROF_PONDERATION.ponderation_Max
        , CAST(IIF ( ponderation_PUBLIC = 1, 1, 0 ) AS BIT) as goodToGo FROM MyMEQ_COURSESTUDENT INNER JOIN MyMEQ_PROF_NOTES ON MyMEQ_COURSESTUDENT.cs_ID = MyMEQ_PROF_NOTES.cs_ID INNER JOIN MyMEQ_PROF_PONDERATION ON MyMEQ_PROF_NOTES.ponderation_ID = MyMEQ_PROF_PONDERATION.ponderation_ID
        WHERE MyMEQ_COURSESTUDENT.student_ID = ` + this.student_id + ` AND MyMEQ_COURSESTUDENT.group_ID = ` + this.group_id + `   
        ORDER BY ponderation_Order`
console.log(sql)
        axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(sql))
        .then(res => { 
            if (!res.data[0]) { this.no_display = 'Nothing to see yet ....'}
            this.data_ponderation = res.data
            
        }); */




}, // END GET DETAILS

return_average(val,max) {
    return Math.round((val / max) * 100) + '%'
},
format_average(val) {
    return Math.round(val)
},



  }, // END METHODS 

} // END SCRIPT
</script>





<style scoped>

.doFont {
  font-size: 4.0vmin;
}
.doFontSmaller {
  font-size: 2.0vmin;
}

</style>
